import React from 'react';
import { Link } from 'react-router-dom';
import { Private_Routes } from '../../../../constants';
import { LiquidatedOvertimeHourModel } from '../../models/liquidateOvertimeHours';

interface Props {
    activeTab: string;
    label: string;
    tabValue: string;
    setSelectedList: (item: LiquidatedOvertimeHourModel[]) => void;
}

export const TabLink = ({ tabValue, label, activeTab, setSelectedList }: Props) => (
    <li className='nav-item'>
        <Link
            className={`nav-link ${
                activeTab === tabValue ? 'active bg-light text-dark' : ''
            }`}
            to={Private_Routes.MANAGE_PAYROLL_NOVELTY.index.replace(
                ':tab',
                tabValue
            )}
            onClick={() => {
                setSelectedList([]);
            }}
            style={{ cursor: 'pointer' }}
        >
            {label}
        </Link>
    </li>
);
